<template>
  <InfoTableBase
    heading="onlineTutorialsHeading"
    title-key="table.newFeatures"
    :fetch-api="MaintainNewsApi.getNewFeaturesList"
  />
</template>

<script>
import { MaintainNewsApi } from '@/api';
import InfoTableBase from './components/InfoTableBase.vue';

export default {
  components: { InfoTableBase },
  data: () => ({ MaintainNewsApi }),
};
</script>
